import { Component, OnInit } from '@angular/core';
import { EmployeeService } from '../../../../../shared/_services/employee.service';

@Component({
  selector: 'app-employee-transaction-history',
  templateUrl: './employee-transaction-history.component.html',
  styleUrls: ['./employee-transaction-history.component.scss']
})
export class EmployeeTransactionHistoryComponent implements OnInit {
  employeeId: any;
  p: number = 0;
  size: number = 10;
  totalCount: number;
  tableHeader: any = [
    { 'key': 'Created at/Status', 'property': 'transactionDate', 'direction': 'asc' },
    { 'key': 'Transtype/Hotel', 'property': 'transactionTypeName', 'direction': null },
    { 'key': 'Points', 'property': 'points', 'direction': null },
    { 'key': 'Cash Paid', 'property': 'cashPaid', 'direction': null },
    { 'key': 'Quantity', 'property': 'quantity', 'direction': null },
    { 'key': 'Nights', 'property': 'nights', 'direction': null },
    { 'key': 'Updated at', 'property': 'updatedDateStr', 'direction': null }
  ];
  transactionList: any[] = [];
  constructor(
    private employeeService: EmployeeService
  ) { }

  sortTable(property: any, ignoreFields?) {
    this.tableHeader.forEach((header: any) => {
      if (header.property === property && (ignoreFields && ignoreFields.length && ignoreFields.indexOf(property) == -1)) {
        header.direction = header.direction && header.direction == 'asc' ? 'desc' : 'asc';
        // header.direction = !header.direction;
      }
      if (header.property !== property && (ignoreFields && ignoreFields.length && ignoreFields.indexOf(property) == -1)) {
        header.direction = null;
      }
    });
    if (ignoreFields && ignoreFields.length && ignoreFields.indexOf(property) == -1) {
      this.pageChanged(1);
    }
  }

  pageChanged($event) {
    let page = $event - 1;
    this.getEmployeeTransactionHistory(this.employeeId, page);
    this.p = $event;
  }

  getEmployeeTransactionHistory(empId?, page?) {
    let data = {
      page: page != null ? page : this.p,
      sorting: this.tableHeader
    }
    this.employeeService.getEmployeeTransactionHistory(empId, data).subscribe(res => {
      if (res.error == 0) {
        this.transactionList = res.responseObj.results;
        this.totalCount = res.responseObj.totalRecords;
      }
    })
  }

  ngOnInit() {
    this.employeeId = this.employeeService.employeeId;
    this.getEmployeeTransactionHistory(this.employeeId);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/employees/employee-transaction-history/employee-transaction-history.component.ts